import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Team } from 'app/models/team';
import { Globals } from 'app/services/globals'
import { tap } from 'rxjs/operators';
import { of } from 'rxjs';
import { UserService } from './user.service';

@Injectable({ providedIn: 'root' })
export class TeamService {
    private _cachedTeams: Team[] = null;

    public get cachedTeams() : Team[] {
        if (!this._cachedTeams) {
            this._cachedTeams = [];
            this.getAll().subscribe();
        }
        return this._cachedTeams;
    }

    constructor(private http: HttpClient, private globals: Globals, private userService: UserService) {
        this.userService.currentUser.subscribe(user => {
            if (user && this.globals.api_base_url) {
                this.getAll().subscribe();
            }
        });
    }

    getAll(include_users = false) {
        var options:any = { 'include_users': (include_users)? '1': '0'};
        return (include_users == false && this._cachedTeams && this._cachedTeams.length > 0 )? of(this._cachedTeams): this.http.get<Team[]>(`${this.globals.api_base_url}/teams`, { params: options}).pipe(tap(t => this._cachedTeams = t));
    }

    add(data: Object) {
        return this.http.post<Team>(`${this.globals.api_base_url}/team`, data).pipe(tap(() => {
            this._cachedTeams = [];
        }));
    }

    update(team: Team) {
        return this.http.put<Team>(`${this.globals.api_base_url}/team/${team.id}`, team).pipe(tap(() => {
            this._cachedTeams = [];
        }));
    }

    deactivate(id: number) {
        return this.http.delete(`${this.globals.api_base_url}/team/${id}`).pipe(tap(() => {
            this._cachedTeams = [];
        }));
    }

    restore(id: number) {
        return this.http.post(`${this.globals.api_base_url}/team/${id}/restore`, {}).pipe(tap(() => {
            this._cachedTeams = [];
        }));
    }

}